import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { Modal } from '../../cdl/Modal/Modal';
import { useRole } from '../../common/hooks/useRole';

import { GroupAdminModalContent } from './GroupAdminModalContent';
import { useAcceptGtc } from './useAcceptGtc';
import { UserModalContent } from './UserModalContent';

export const AcceptTerms = () => {
    const role = useRole();
    const acceptGtc = useAcceptGtc();
    const navigate = useNavigate();
    const [showAcceptTerms, setShowAcceptTerms] = useState(!role.hasTermsAndConditionsAccepted());

    const logOut = () => {
        navigate({
            to: '/logout',
        });
    };

    const onAccept = async (newsletter: boolean) => {
        acceptGtc(newsletter)
            .then(() => setShowAcceptTerms(false))
            .catch(() => logOut());
    };

    if (role.isSuperAdmin()) {
        return null;
    }

    return (
        <Modal isOpen={showAcceptTerms} dismissible={false}>
            {role.hasAdminRights() ? (
                <GroupAdminModalContent onLogOut={logOut} onAccept={onAccept} />
            ) : (
                <UserModalContent onLogOut={logOut} />
            )}
        </Modal>
    );
};
